import { render, staticRenderFns } from "./SelectPlanItem.vue?vue&type=template&id=f2880660&scoped=true&"
import script from "./SelectPlanItem.vue?vue&type=script&lang=ts&"
export * from "./SelectPlanItem.vue?vue&type=script&lang=ts&"
import style0 from "./SelectPlanItem.vue?vue&type=style&index=0&id=f2880660&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2880660",
  null
  
)

export default component.exports